<template lang="html">
  <div class="main-container">
    <!-- Author: Vaishnavi
      Date: 10/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
        <div class="margintop-32" />
    <tl-header type="h1">Onboarding</tl-header>
    <div class="container-header">Basic Details</div>
    <div class="user-details">
      <div class="user-info">
        <div class="user-info1">
        <img src="@/assets/user@2x.png" class="user-img" />
        <div class="details-header">Chetan Sharma</div>
        <div class="info-type1">RC34566</div>
      </div>
        <div class="user-info2">
          <div class="info-type1">Joined Since 24 March 2018</div>
          <div class="info-type1"> : 8998923299</div>
          <div class="info-type1"> : chetan.sharma@teamlease.com</div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="details">
        <div class="details-header">Basic Information</div>
        <div class="info_type3">
          <div class="info_type4">
            <div class="attribute">First Name</div>
            <div class="value">Chetan</div>
          </div>
          <div class="info_type4">
            <div class="attribute">Last Name</div>
            <div class="value">Sharma</div>
          </div>
          <div class="info_type4">
            <div class="attribute">Date of Birth</div>
            <div class="value">29/03/1990</div>
          </div>
          <div class="info_type4">
            <div class="attribute">Nationality</div>
            <div class="value">Indian</div>
          </div>
          <div class="info_type4">
            <div class="attribute">Blood Group</div>
            <div class="value">B+</div>
          </div>
        </div>
        <div class="divider-horizontal"></div>
        <div class="details-header">Company Information</div>
        <div class="info_type3">
          <div class="info_type4">
            <div class="attribute">Role</div>
            <div class="value">Manager</div>
          </div>
          <div class="info_type4">
            <div class="attribute">Department</div>
            <div class="value">Product Department</div>
          </div>
          <div class="info_type4">
            <div class="attribute">Location</div>
            <div class="value">Head Office</div>
          </div>
          <div class="info_type4">
            <div class="attribute">Employment Type</div>
            <div class="value">Permanent</div>
          </div>
        </div>
        <div class="divider-horizontal"></div>
        <div class="details-header">Reporting to: </div>
        <div class="info_type3">
            <div class="value">Rahul</div>
        </div>
      </div>
    </div>
    <div class="container-header">Documents</div>
    <div class="search-bar"><tl-search /></div>
    <data-table 
      :columns="columnNames" 
      :tableData="employeeData"
      :checkbox="true" />
    <div class="modal" v-show="showDocument">
      <div class="modal-content">
        <document-screen></document-screen>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentScreen from './employees/employeeDocuments.vue';

export default {
    components: {
      DocumentScreen
    },
    data() {
      return {
        breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Offers",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/offers`
              }
            ],
        columnNames: [{
            label: 'Name',
            key: 'name'
          },
          {
            label: 'File Name',
            key: 'fileName'
          },
          {
            label: 'Upload Date',
            key: 'uploadDate'
          }
        ],
        employeeData: [{
          name: 'Adhaar Card',
          fileName: 'jeevanadhaar.pdf',
          uploadDate: '03/01/2019'
        },
        {
          name: 'Pan Card',
          fileName: 'Cpancard.pdf',
          uploadDate: '03/01/2019'
        },
        {
          name: 'Passport',
          fileName: 'passportc.pdf',
          uploadDate: '03/01/2019'
        },
        {
          name: '10th Document',
          fileName: '10doc.pdf',
          uploadDate: '03/01/2019'
        },
        {
          name: '12th Document',
          fileName: '12doc.pdf',
          uploadDate: '03/01/2019'
        },
        {
          name: 'UG Degree',
          fileName: 'ug.pdf',
          uploadDate: '03/01/2019'
        }
      ],
      showDocument: false
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../../../../scss/_variables.scss';
@import "@/scss/components/margins.scss"; 
.user-details {
  width: 100%;
  height: auto;
  background-color: #f9f9f9;
  display: flex;
}
.user-info {
  width: 30%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px;
  height: 100%;
  align-items: center;
}
.user-info1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.user-img {
  height: 150px;
  width: 150px;
}
.container-header {
  color: #000000;
  font-size: 14px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 20px;
}
.search-bar {
  margin-bottom: 20px;
}
.divider {
  padding-top: 40px;
  padding-bottom: 40px;
  margin: 35px 0 35px 0;
  border-right: solid 1px #dadada;
}
.details {
  // margin: 35px 0 35px 0;
  padding: 40px;
}
.divider-horizontal {
  padding-right: 40px;
  padding-left: 20px;
  // margin: 35px 0 35px 0;
  border-bottom: solid 1px #dadada;
}
.details-header {
  color: #303030;
  font-size: 14px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 20px;
}
.info-type1 {
  color: #808080;
  font-size: 14px;
  margin: 20px 0 0 0;
}
.user-info2 {
  &.info-type1 {
    margin-top: 20px;
  }
  * {
    margin-top: 20px;
  }
}
.info_type3 {
  display: flex;
  padding: 20px;
}
.info_type4 {
  margin: 0px 25px 15px 0px;
  display: flex;
  flex-direction: column;
}
.attribute {
  font-size: 12px;
  color: #808080;
  margin-bottom: 20px;
}
.value {
  font-size: 14px;
  color: #808080;
}
.modal {
  display: block;
  position: absolute;
  z-index: 2;
  // padding-top: 100px;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0,0,0,0.3);
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  border: 1px solid $color-secondary;
  width: 80%;
  z-index: 20;
  border-radius: 4px;
}
</style>
